import React from 'react'
import Navbar from '../components/Navbar'
import Baner from '../components/Baner'
import bg from '../assets/bg-onas.jpg'
import Footer from '../components/Footer'

import krzysztof from '../assets/krzysztof.jpg'
import lukasz from '../assets/lukasz.jpg'
import remigiusz from '../assets/remigiusz.png'
import agnieszka from '../assets/agnieszka.jpg'
import maksymilian from '../assets/maksymilian.jpg'

const ONas = () => {

  const onasItems = [
    {
      id: 1,
      text: "Geneza",
      text2: "Wymagania rynku zainspirowały nas do stworzenia profesjonalnej firmy konsultingowej zaspokajającej wszechstronnie potrzeby klientów zarówno w zakresie szeroko pojętych usług finansowych oraz doradztwa prawnego. Stworzyliśmy firmę w oparciu o wysokiej klasy ekspertów z różnych dziedzin gospodarki. Stawiamy na rozwój. Nieustanne pracowanie nad sobą uznajemy za swój priorytet",
    },  {
      id: 2,
      text: "Profesjonalizm",
      text2: "Pracownicy i Współpracownicy naszej firmy reprezentują wieloletnie doświadczenie, które poparte jest licznymi sukcesami związanymi z szeroko pojętą branżą Finansową i Prawną. Cechuje nas indywidualne podejście do każdego Klienta. Nasza kadra zapewnia niezbędną i przede wszystkim fachową pomoc w zakresie Prawa i Finansów.",
    },  {
      id: 3,
      text: "Nasza wizja",
      text2: "Nasza firma pragnie dostarczyć Klientom produkty szyte na miarę ich potrzeb. Kierujemy się zasadami uczciwości, lojalności i szczerości. U nas każdy Klient może liczyć na profesjonalną obsługę oraz pomoc. Nasza firma wie, jak ważne dla Klienta jest zaufanie, stabilność oraz perspektywa uczciwej współpracy. Chcemy być firmą, która budzi pozytywne skojarzenia, firmą, której zaufasz.",
    }, 
  ]

  const osoby = [
    {
      id: 1,
      name: "Krzysztof Sikora",
      prof: "Ekspert finansowy",
      text: "Magister Wydziału Ekonomicznego Politechniki Gdańskiej. Od 2002 roku nieprzerwanie związany z bankowością. Począwszy od stanowiska doradcy, by zdobywając szerokie doświadczenie w aspekcie finansów awansować na stanowiska kierownicze w międzynarodowych korporacjach finansowych. Stale rosnące grono poleconych klientów jest dowodem jego skuteczności w realizacji ich indywidualnych potrzeb i oczekiwań. To właśnie bezpośrednia praca z klientem, a przede wszystkim jego zadowolenie i satysfakcja dają mu motywację do dalszej pracy.​​",
      img: krzysztof,
    }, {
      id: 2,
      name: "Łukasz Onichimowski",
      prof: "Ekspert finansowy",
      text: "Manager z urodzenia i zamiłowania. Wieloletnie doświadczenie poparte sukcesami w sprzedaży bezpośredniej produktów bankowych i zarządzaniu zespołem w Międzynarodowym Banku. Absolwent Uniwersytetu Mikołaja Kopernika w Toruniu na Wydziale Prawa i Administracji.Wieloletnie doświadczenie w bankowości przyczyniło się do otworzenia własnej Firmy Konsultingowej. Specjalizuje się w skutecznym załatwieniu kredytowania zarówno dla klienta indywidualnego jak i dla firmy.​​​",
      img: lukasz,
    },{
      id: 3,
      name: "Maksymilian Paśko",
      prof: "Adwokat",
      text: "Adwokat z 20-letnią praktyką w zawodzie, absolwent prawa na Uniwersytecie Gdańskim. W latach 2002-2005 odbył aplikacje sądową, zakończoną złożeniem egzaminu sędziowskiego. Obecnie z sukcesem prowadzi własną kancelarię, łącząc to z pracą naukowo-dydaktyczną jako wykładowca w Katedrze Zarządzania Turystyką i Rekreacją Akademii Wychowania Fizycznego i Sportu w Gdańsku. Wieloletni konsultant prawny m.in.  Pomorskiego Oddziału Polskiej Izby Turystyki, Polskiego Związku Żeglarskiego. Autor publikacji naukowych oraz monografii z zakresu prawa cywilnego, przewozowego, turystycznego, sportowego oraz ochrony danych osobowych, które aktywnie przedstawia na konferencjach branżowych. Jego misją jest człowiek poszukujący rzetelnej i jakościowej pomocy prawnej. Miłośnik kultury i historii Gdańska.​​​​",
      img: maksymilian,
    },{
      id: 4,
      name: "DR Remigiusz Dróżdż",
      prof: "Ekspert ds. projektów inwestycyjnych",
      text: "Doktor nauk o kulturze fizycznej oraz specjalista od zarządzania w  turystyce i hotelarstwie. Sądowy Zarządca Hoteli.  Wieloletni członek komisji kategoryzacyjnej : obiekty hotelarskie w województwie pomorskim.   Autor ponad 80 publikacji naukowych w tym 10 monografii z tej dziedziny. Członek  Rady Naczelnej Polskiej Izby Turystyki oraz Prezes Oddziału Pomorskiego Polskiej Izby Turystyki.   Specjalista od pro –openingu hotelowego i nowoczesnych systemów sprzedaży OTA. Doświadczenie zawodowe: Chopin Airport Development, Best Western, Port Hotel , Hotel Skipper, Hotel Szymbark, Hotel Artus, Hotel Miramar,  Aparthotel , Hotel Jurata, Hotel Mellaves, Hotel Olimp , Hostel 3 City , Sanatorium Perła, Hotel Continental w Krynica Morska etc.​​​",
      img: remigiusz,
    },{
      id: 5,
      name: "Agnieszka Kochanowska-Onichimowska",
      prof: "HR Business Partner",
      text: "Dyplomowany HR Business Partner, dyplomowany trener, konsultant HR. Menadżer z ponad 15 letnim stażem w zarzadzaniu sprzedażą w branży Finanse & Banking. Posiada 12-letnią praktykę w rekrutacji na stanowiska sprzedażowe menadżerskie. Swoje dotychczasowe doświadczenie aktywnie wykorzystuje w doradztwie Firmom w zakresie rozwoju kompetencji pracowników, rekrutacji i selekcji, strategii personalnej, oceniania pracowników a także zarządzania efektywnością  pracy. Prowadzi, jako certyfikowany trener sprzedaży szkolenia w zakresie technik sprzedaży, komunikacji, autoprezentacji czy budowania zespołów sprzedażowych, a hobbistycznie tworzy programy rozwojowo-szkoleniowe. Z zamiłowania wykonuje sesje Development i Assessment Centre. W swoim życiu kieruje się jakością i wysokimi standardami, a praca z drugim człowiekiem to dla niej pasja. Uważa bowiem, iż  budowanie długotrwałych relacji biznesowych, analizowanie potrzeb klientów i dostosowanie oferty do potrzeb rynku to recepta do osiągnięcia wspólnego sukcesu​​",
      img: agnieszka,
    },
  ]

  return (
    <div>
      <Navbar />
      <Baner bg={bg} text="O NAS" text2=""/>
      <div className='w-full'>
        <div className='justify-center flex mx-auto max-w-[1450px] bg-white'>
          <div className='text-sm sm:text-base'>
            <div className='text-center mx-14 pt-10'>
              <h2 className='font-semibold pb-4 text-lg sm:text-xl'>O FIRMIE</h2>
              <p>Firma Oniko-Expert Sp. z o.o. to przedsiębiorstwo konsultingowe, które w ramach swoich usług zajmuje się doradztwem w zakresie finansów i prawa. Wieloletnie doświadczenie na rynku zdobyte przez naszych pracowników i współpracowników pozwoliło nam stworzyć firmę przyjazną każdemu Klientowi, firmę, którą wyróżnia precyzja, dokładność oraz dbałość o relację z Klientem.</p>
            </div>
            <div className='grid lg:grid-cols-3'>
                {onasItems.map((item) => (
                  <div key={item.id} className='text-center mx-10 mt-10 bg-gray-50 rounded-xl py-4 px-4'>
                    <h2 className='font-semibold pb-4 text-lg sm:text-xl'>{item.text}</h2>
                    <p>{item.text2}</p>
                  </div> 
                ))}
              </div>
              <div className='grid md:grid-cols-2 pt-20 md:px-10 text-center'>
                  {osoby.map((item) => (
                    <div key={item.id} className='mx-20 pt-20'>
                      <img src={item.img} alt="background" className='rounded-full sm:h-[170px] sm:w-[170px] h-[120px] w-[120px] object-cover mx-auto'/>
                      <h2 className='font-semibold text-xl sm:text-2xl pt-2'>{item.name}</h2>
                      <h3 className='text-lg sm:text-xl pb-4'>{item.prof}</h3>
                      <p>{item.text}</p>
                    </div>
                  ))}
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default ONas